module.exports = __webpack_public_path__ + "static/img/carousel_fmj16.e6138e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/carousel_fmj16.jpg
// module id = x9yP
// module chunks = 0